// src/services/eventsService.js
import { collection, deleteDoc, doc, getDocs, addDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const eventsRef = () => collection(db, 'events');

export const getAllEvents = async () => {
  const snap = await getDocs(eventsRef());
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
};

export const getActiveEvents = async () => {
  const all = await getAllEvents();
  const now = Date.now();
  return all.filter((ev) => {
    const start = ev.startAt ? new Date(ev.startAt).getTime() : null;
    const end = ev.endAt ? new Date(ev.endAt).getTime() : null;
    if (start != null && now < start) return false;
    if (end != null && now > end) return false;
    return true;
  });
};

export const createEvent = async (payload) => {
  const nowISO = new Date().toISOString();
  const ref = await addDoc(eventsRef(), {
    ...payload,
    createdAt: nowISO,
    lastUpdated: nowISO
  });
  return ref.id;
};

export const updateEvent = async (id, payload) => {
  await updateDoc(doc(db, 'events', id), {
    ...payload,
    lastUpdated: new Date().toISOString()
  });
};

export const deleteEvent = async (id) => {
  await deleteDoc(doc(db, 'events', id));
};
